/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { HistoryMemoRequest } from '../models/HistoryMemoRequest';
import type { PaginatedResponse_TaskSubGroupResponse_ } from '../models/PaginatedResponse_TaskSubGroupResponse_';
import type { TaskSubGroupCreateRequest } from '../models/TaskSubGroupCreateRequest';
import type { TaskSubGroupResponse } from '../models/TaskSubGroupResponse';
import type { TaskSubGroupSortRequest } from '../models/TaskSubGroupSortRequest';
import type { TaskSubGroupUpdateRequest } from '../models/TaskSubGroupUpdateRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class TaskSubgroupService {
    /**
     * Create Task Subgroup
     * 전략과제 하위그룹 생성
     *
     * 새로운 전략과제 하위그룹을 생성합니다.
     * @returns TaskSubGroupResponse Created
     * @throws ApiError
     */
    public static appsTaskViewsCreateTaskSubgroup({
        requestBody,
    }: {
        requestBody: TaskSubGroupCreateRequest,
    }): CancelablePromise<TaskSubGroupResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/task/subgroup',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                409: `Conflict`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * List Task Subgroups
     * 전략과제 하위그룹 목록 조회 및 검색
     *
     * 전략과제 하위그룹을 페이징하여 조회하거나 키워드로 검색합니다.
     *
     * Args:
     * q: 검색 키워드 (선택사항)
     * task_group_id: 전략과제 ID로 필터링 (선택사항)
     * @returns PaginatedResponse_TaskSubGroupResponse_ OK
     * @throws ApiError
     */
    public static appsTaskViewsListTaskSubgroups({
        q,
        taskGroupId,
        page = 1,
        perPage = 100,
    }: {
        q?: string,
        taskGroupId?: string,
        page?: number,
        perPage?: number,
    }): CancelablePromise<PaginatedResponse_TaskSubGroupResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/task/subgroup',
            query: {
                'q': q,
                'task_group_id': taskGroupId,
                'page': page,
                'per_page': perPage,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get Task Subgroup
     * 전략과제 하위그룹 조회
     *
     * ID로 특정 전략과제 하위그룹을 조회합니다.
     * @returns TaskSubGroupResponse OK
     * @throws ApiError
     */
    public static appsTaskViewsGetTaskSubgroup({
        subGroupId,
    }: {
        subGroupId: string,
    }): CancelablePromise<TaskSubGroupResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/task/subgroup/{sub_group_id}',
            path: {
                'sub_group_id': subGroupId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update Task Subgroup
     * 전략과제 하위그룹 정보 수정
     *
     * 특정 전략과제 하위그룹의 정보를 수정합니다.
     * @returns TaskSubGroupResponse OK
     * @throws ApiError
     */
    public static appsTaskViewsUpdateTaskSubgroup({
        subGroupId,
        requestBody,
    }: {
        subGroupId: string,
        requestBody: TaskSubGroupUpdateRequest,
    }): CancelablePromise<TaskSubGroupResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/task/subgroup/{sub_group_id}',
            path: {
                'sub_group_id': subGroupId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Delete Task Sub Group
     * 전략과제 하위그룹 삭제
     *
     * 특정 전략과제 하위그룹을 삭제합니다. (소프트 삭제)
     * 선택적으로 body 에 memo 를 담으면 history 에 기록됩니다.
     * @returns void
     * @throws ApiError
     */
    public static appsTaskViewsDeleteTaskSubGroup({
        subGroupId,
        requestBody,
    }: {
        subGroupId: string,
        requestBody?: HistoryMemoRequest,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/task/subgroup/{sub_group_id}',
            path: {
                'sub_group_id': subGroupId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update Task Sub Group Sort
     * 전략과제 하위그룹 정렬 순서 변경
     *
     * prev_task_sub_group_id와 next_task_sub_group_id 사이로 정렬 순서를 변경합니다.
     * - 맨 앞으로 이동: prev_task_sub_group_id=None, next_task_sub_group_id=첫번째ID
     * - 맨 뒤로 이동: prev_task_sub_group_id=마지막ID, next_task_sub_group_id=None
     * - 중간으로 이동: prev_task_sub_group_id=이전ID, next_task_sub_group_id=다음ID
     * @returns TaskSubGroupResponse OK
     * @throws ApiError
     */
    public static appsTaskViewsUpdateTaskSubGroupSort({
        subGroupId,
        requestBody,
    }: {
        subGroupId: string,
        requestBody: TaskSubGroupSortRequest,
    }): CancelablePromise<TaskSubGroupResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/task/subgroup/{sub_group_id}/sort',
            path: {
                'sub_group_id': subGroupId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
}
